import React, { useContext, useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../css/Footer.css";
import { MouseContext } from ".././context/MouseContext";
import emailjs from "@emailjs/browser";
import { HiMail, HiPhone, HiStar, HiExternalLink } from "react-icons/hi";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { MdSend } from "react-icons/md";
import { projects } from "../projects-data/projects-data";
import { motion } from "framer-motion";

const Footer = () => {
  const { cursorChangeHandler } = useContext(MouseContext);

  const email = process.env.REACT_APP_PERSONAL_INFO_EMAIL || "gianesg19@gmail.com";
  const phone = process.env.REACT_APP_PERSONAL_INFO_PHONE || "+639308660464";
  const linkedin = process.env.REACT_APP_PERSONAL_INFO_LINKEDIN || "https://www.linkedin.com/in/gian-web-dev";
  const github = process.env.REACT_APP_PERSONAL_INFO_GITHUB || "https://github.com/lucky-leaf-x9";

  // Format phone for display (add space after country code)
  const phoneDisplay = phone.replace(/^(\+\d{2})(\d+)$/, "$1 $2");
  // Extract display text from URLs
  const githubDisplay = github.replace(/^https?:\/\/(www\.)?/, "");
  const linkedinDisplay = linkedin.replace(/^https?:\/\/(www\.)?/, "");

  const featuredProjects = projects.map((project) => ({
    id: project.id,
    name: project.title,
    url: project.link,
  }));

  const form = useRef();
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Massage, setMassage] = useState("");
  const [notification, setNotification] = useState({ show: false, message: "", type: "" });

  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification({ show: false, message: "", type: "" });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [notification.show]);

  const sendEmail = (e) => {
    e.preventDefault();

    setName("");
    setEmail("");
    setMassage("");

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          setNotification({
            show: true,
            message: "✅ Success! Your email has been sent successfully.",
            type: "success",
          });
        },
        (error) => {
          console.log(error.text);
          setNotification({
            show: true,
            message: "❌ Error! Failed to send email. Please try again later.",
            type: "error",
          });
        }
      );
  };

  return (
    <footer id="footer">
      <div className="wrapper">
        <div className="footer-row">
          <div className="contact-info">
            <h3>
              Contact&nbsp;
              information
            </h3>
            <p>
              Feel free to reach out to me any time. I don't mind speaking over
              any media outlet.
            </p>
            <ul>
              <li>
                <HiMail className="email-icon" />
                <NavLink
                  to={`mailto:${email}`}
                  onMouseEnter={() => cursorChangeHandler("hovered")}
                  onMouseLeave={() => cursorChangeHandler("")}
                  className={({ isActive }) => (isActive ? "special active" : "special")}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${email}`;
                  }}
                >
                  {email}
                </NavLink>
              </li>
              <li>
                <HiPhone className="phone-icon" />
                <NavLink
                  to={`tel:${phone}`}
                  onMouseEnter={() => cursorChangeHandler("hovered")}
                  onMouseLeave={() => cursorChangeHandler("")}
                  className={({ isActive }) => (isActive ? "special active" : "special")}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `tel:${phone}`;
                  }}
                >
                  {phoneDisplay}
                </NavLink>
              </li>
              <li>
                <FaGithub className="email-icon" />
                <NavLink
                  to={github}
                  onMouseEnter={() => cursorChangeHandler("hovered")}
                  onMouseLeave={() => cursorChangeHandler("")}
                  className={({ isActive }) => (isActive ? "special active" : "special")}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(github, "_blank");
                  }}
                >
                  {githubDisplay}
                </NavLink>
              </li>
              <li>
                <FaLinkedinIn className="email-icon" />
                <NavLink
                  to={linkedin}
                  onMouseEnter={() => cursorChangeHandler("hovered")}
                  onMouseLeave={() => cursorChangeHandler("")}
                  className={({ isActive }) => (isActive ? "special active" : "special")}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(linkedin, "_blank");
                  }}
                >
                  {linkedinDisplay}
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="contact footer">
            <div className="contact-form">
              <form ref={form} onSubmit={sendEmail}>
                <div className="row">
                  <div className="input-wrapper">
                    <label>Name</label>
                    <input
                      placeholder="Your name?"
                      type="text"
                      name="name"
                      required
                      onChange={(event) => setName(event.target.value)}
                      value={Name}
                    />
                    <span className="input-bottom-line"></span>
                  </div>
                  <div className="input-wrapper">
                    <label>Email</label>
                    <input
                      placeholder="Your email?"
                      type="email"
                      name="user_email"
                      required
                      onChange={(event) => setEmail(event.target.value)}
                      value={Email}
                    />
                    <span className="input-bottom-line"></span>
                  </div>
                </div>
                <div className="row textarea-row">
                  <div className="input-wrapper">
                    <label>Message</label>
                    <textarea
                      placeholder="What’s your message?"
                      name="message"
                      required
                      onChange={(event) => setMassage(event.target.value)}
                      value={Massage}
                    />
                    <span className="input-bottom-line"></span>
                  </div>
                </div>
                <div
                  onMouseEnter={() => cursorChangeHandler("hovered")}
                  onMouseLeave={() => cursorChangeHandler("")}
                  className="submit-button"
                >
                  <input type="submit" value="Send message" />
                  <MdSend className="send-icon" />
                </div>
                {notification.show && (
                  <motion.div
                    className={`email-notification ${notification.type}`}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    {notification.message}
                  </motion.div>
                )}
              </form>
            </div>
          </div>
          <div className="latest-projects">
            <h3>
              <HiStar className="featured-icon" />
              <span>Featured projects</span>
            </h3>
            <ul className="projects-links">
              {featuredProjects.map((project) => (
                <li
                  key={project.id}
                  onMouseEnter={() => cursorChangeHandler("hovered")}
                  onMouseLeave={() => cursorChangeHandler("")}
                >
                  <NavLink
                    to={project.url}
                    className={({ isActive }) => (isActive ? "special active" : "special")}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(project.url, "_blank");
                    }}
                  >
                    <span className="link-icon">
                      <HiExternalLink />
                    </span>
                    <span>{project.name}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
          <div className="copyright"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
